import Cms from '@components/cms/Cms.component';
import {getCmsPageProps} from '@utils/cms';

const Page = props => {
	const {cmsdata} = props;

	if (!cmsdata?.result?.cms) return null;

	// Process CMS data to replace text
	const processedCmsData = {
		...cmsdata,
		result: {
			...cmsdata.result,
			cms: {
				...cmsdata.result.cms,
				raw_data: (cmsdata.result.cms.raw_data || '')
					.replace(/Better That/g, 'Ditybit')
					.replace(/Change of Mind/g, 'No-Refund Policy for Change of Mind'),
			},
		},
	};

	return (
		<>
			<Cms cmsdata={processedCmsData.result.cms}></Cms>
			<div id='dynamicstyle'></div>
		</>
	);
};

export async function getStaticProps({params}) {
	const slug = '/return-policy';
	const cmsdata = await getCmsPageProps(slug);

	return {
		props: {
			cmsdata,
		},
		revalidate: 60 * 15,
	};
}

Page.Layout = true;
export default Page;
